import { type CreationContextParams } from '@atlassian/conversation-assistant-external-context/types';

const REMIX_EDIT_BLOCKS = ['chart', 'diagram', 'visual-aid', 'infographic', 'image'];

export function getCreationContextBlocks({
	existingBlocks,
	experience,
	source,
	contentMauiId,
	mediaFileId,
	dynamicUiType,
	isCreationContextContractEnabled = false,
}: {
	existingBlocks: string[] | undefined;
	experience: CreationContextParams['experience'] | undefined;
	source: string | undefined;
	contentMauiId?: string;
	mediaFileId?: string;
	dynamicUiType?: string;
	isCreationContextContractEnabled?: boolean;
}): string[] | undefined {
	if (existingBlocks && existingBlocks.length > 0) {
		return existingBlocks;
	}

	if (isCreationContextContractEnabled && experience === 'remix_edit') {
		if (dynamicUiType && REMIX_EDIT_BLOCKS.includes(dynamicUiType)) {
			return [dynamicUiType];
		}

		// The contract requires a block on every remix edit. The exact value matters less than its
		// presence: the MAUI types are handled by one subagent and the image types by another, so
		// fall back to the block family implied by the content reference.
		return mediaFileId && !contentMauiId ? ['image'] : ['chart'];
	}

	if (source === 'remix' && experience === 'remix_edit' && mediaFileId) {
		return ['image'];
	}

	return undefined;
}
